export const operatingLimits = {
  normalOperatingLimit: 96,
  safeOperatingLimit: 139,
  safeDesignLimit: 218,
};
